import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { GlobalConstants } from '../../../../../src/app/common/constants/global.constant';
import { DevicesConstants } from '../../../core/routing/services/devices/constants/devices.constants';
import { DeviceStoreService } from '../store/device.store';
import { FormBuilder } from '@angular/forms';
import { GoogleAnalyticsService } from '../../../../app/modules/google-analytics/google-analytics.service';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'iposcen-device-price-content',
  templateUrl: './device-price-content.component.html',
  styleUrls: ['./device-price-content.component.scss']
})
export class DevicePriceContentComponent implements OnInit {

  placeholderPrimaryPrice: string = $localize`:@@active-device-report.search-input.placeholder:Enter Primary Price`;
  placeholderSecondaryPrice: string = $localize`:@@active-device-report.search-input.placeholder:Enter Secondary Price`;
  @Input() deviceInfo;
  @Input() selectedLength;
  @Input() priceMetaData;
  @ViewChild('ClipBoard') tooltip: NgbTooltip;
  isPriceContent = false;
  priceLength;
  primaryColor: string;
  secondaryColor: string;
  backgroundColor: string;
  priceDescriptionColor: string;
  iposBackgroundType: string;
  noneSelected;
  largePriceSelected;
  priceContentSelected;
  isPriceStrickEnabel;
  segmentThemeForm;
  brandColorThemeForm;
  @Output() readonly getPriceStatus = new EventEmitter();
  @Output() readonly dismissFunc = new EventEmitter();
  cancelBtn = GlobalConstants.CANCEL;
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  buttonLabelCancel = DevicesConstants.CANCEL_UPDATE;
  buttonLabelNo = DevicesConstants.NO;
  saveChanges = GlobalConstants.SAVE_CHANGES;
  cancelChanges = GlobalConstants.CANCEL;
  successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
  description = DevicesConstants.DEVICE_UPDATE_DESC;
  priceContentEmptyDesc = GlobalConstants.PRICE_CONTENT_EMPTY_TOOLTIP;
  isCancel = false;
  openModalPopup = false;
  openSuccessPopup = false;
  priceStrikethrough;
  payload;
  displayPriceContent = [];
  primaryPrice;
  primaryPriceValue;
  secondaryPriceValue;
  livePreviewData: any = [];
  devicePriceForm;
  priceContantPayload;
  pricePayload;
  priceDescriptionText;
  idselected;
  isPriceEmpty: boolean;
  enableSavechanges = false;
  globalConst = GlobalConstants;
  constructor(private fb: FormBuilder, private deviceStore: DeviceStoreService, private googleAnalyticsService: GoogleAnalyticsService) {
  }

  ngAfterViewInit() {
    // To keep the tooltip open bydefault if SKU is blank
    if(this.priceMetaData?.blockSKU && this.selectedLength && this.priceMetaData?.enablePriceMultiDevices){
      this.tooltip.open();
    }
  }
  ngOnInit(): void {
    this.googleAnalyticsService.devieInfoTabName('Price Content');
    let priceData;
    if (this.deviceInfo?.priceInfo) {
      priceData = this.deviceInfo ? JSON.parse(this.deviceInfo?.priceInfo) : undefined;
    } else {
      priceData = { primaryPrice: undefined, secondaryPrice: undefined };
    }
    const storeData = this.deviceStore.deviceStoreData;
    if (storeData?.priceInfo) {
      const priceInfoData = JSON.parse(storeData?.priceInfo);
      this.priceDescriptionColor = priceInfoData?.price_colors.backgrounds.large_price_callout;
      this.noneSelected = !(priceInfoData?.large_price_callout || storeData?.priceContents);
      this.largePriceSelected = priceInfoData?.large_price_callout;
      this.priceContentSelected = storeData?.priceContents;
      this.priceDescriptionText = priceInfoData?.price_comment;
      this.idselected = !(storeData?.priceContents.length > 0) ? undefined : storeData?.priceContents[0].priceContentId;
      if (!this.selectedLength) {
        this.primaryColor = priceInfoData?.price_colors.fonts.primary;
        this.secondaryColor = priceInfoData?.price_colors.fonts.secondary;
        this.backgroundColor = priceInfoData?.price_colors.backgrounds.price_label;
        this.primaryPriceValue = priceInfoData?.price;
        this.secondaryPriceValue = priceInfoData?.sale_price;
        this.priceStrikethrough = priceInfoData?.price_strikethrough;
      }
    } else {
      this.primaryColor = GlobalConstants.WHITE_COLOR;
      this.secondaryColor = GlobalConstants.WHITE_COLOR;
      this.backgroundColor = GlobalConstants.STORELOGO_BGCOLOR;
      this.priceDescriptionColor = GlobalConstants.STORELOGO_BGCOLOR;
      if (this.selectedLength) {
        this.priceDescriptionText = '';
        this.noneSelected = false;
        this.largePriceSelected = true;
        this.priceContentSelected = false;
        // IIT3-427
        this.primaryPriceValue = '';
        this.secondaryPriceValue = '' 
      } else {
        this.primaryPriceValue = priceData?.primaryPrice ? priceData?.primaryPrice : priceData?.price;
        this.secondaryPriceValue = priceData?.secondaryPrice ? priceData?.secondaryPrice : priceData?.sale_price;
        this.primaryColor = priceData?.price_colors.fonts.primary;
        this.secondaryColor = priceData?.price_colors.fonts.secondary;
        this.backgroundColor = priceData?.price_colors.backgrounds.price_label;
        //Changes as part of UAT-557 starts
        this.noneSelected = !(priceData?.large_price_callout || priceData?.priceContents);
        this.largePriceSelected = priceData?.large_price_callout;
        this.priceContentSelected = priceData?.priceContents;
        this.priceDescriptionText = priceData?.price_comment;
        if ((priceData?.sale_price == '' || priceData?.sale_price) && !priceData?.price_strikethrough) {
          this.priceStrikethrough = false;
        } else if ((priceData?.sale_price == '' || priceData?.sale_price) && priceData?.price_strikethrough) {
          this.priceStrikethrough = true;
        }
        //Changes as part of UAT-557 ends
      }
      this.idselected = undefined;
    }
    this.priceContantPayload = {};
    this.pricePayload = {};
    this.isPriceStrickEnabel = true;
    this.priceLength = 0;
  }

  getPriceLength(event) {
    this.isPriceEmpty = (event > 0) ? false : true;
    this.priceLength = event;
  }

  getPriceInput(event){
    this.enableSavechanges = true;
  }
  
  getSecondaryPriceInput(event){
    this.enableSavechanges = true;
  }

  setPriceContentData(data) {
    this.enableSavechanges = true;
    if (data === 'None') {
      this.priceContantPayload = {
        priceContents :[]
      };
      this.idselected = undefined;
    } else {
      this.priceContantPayload = {
        priceContents: [{
          priceContentId: data.id,
          showOnDevice: true
        }]
      };
      this.idselected = data.id;
    }

  }

  togglePriceStrikethrough() {
    this.enableSavechanges = true;
    this.priceStrikethrough = !this.priceStrikethrough
  }

  priceClickAbility(data) {
    if (data === 'none') {
      this.noneSelected = true;
      this.largePriceSelected = false;
      this.priceContentSelected = false;
      this.priceDescriptionColor = GlobalConstants.STORELOGO_BGCOLOR;
      this.priceDescriptionText = '';

    } else if (data === 'largePrice') {
      this.largePriceSelected = true;
      this.noneSelected = false;
      this.priceContentSelected = false;

    } else {
      this.priceContentSelected = true;
      this.largePriceSelected = false;
      this.noneSelected = false;
      this.priceDescriptionColor = GlobalConstants.STORELOGO_BGCOLOR;
      this.priceDescriptionText = '';
    }

  }
  updateBgColor(value: string, whichcontent) {
    this.enableSavechanges = true;
    if (whichcontent === 'primary') {
      this.primaryColor = value;
    } else if (whichcontent === 'secondary') {
      this.secondaryColor = value;
    } else if (whichcontent === 'backgroundColor') {
      this.backgroundColor = value;
    } else if (whichcontent === 'priceDescription') {
      this.priceDescriptionColor = value;
    }
    this.setLivePreview();
  }
  setLivePreview() {
    this.livePreviewData = [];
    this.livePreviewData.push({
      bgColor: this.primaryColor
    });
  }
  cancel() {
    this.successMessage = DevicesConstants.DEVICE_CANCEL_TITLE;
    this.description = DevicesConstants.DEVICE_CANCEL_DESC;
    this.isCancel = true;
    this.openModalPopup = !this.openModalPopup;
  }

  sendDataToStore() {
    if ( !this.primaryPriceValue || this.primaryPriceValue?.trim() === ''){
      this.secondaryPriceValue = '';
      this.priceStrikethrough = false;
    }
    if (!this.secondaryPriceValue || this.secondaryPriceValue?.trim() === ''){
      this.priceStrikethrough = false;
    }
    this.googleAnalyticsService.devieInfoChangesSaved('Price Content');
    if (this.selectedLength && this.priceMetaData?.enablePriceMultiDevices) {
      let pData = {
        include_price: true,
        price_comment: this.priceDescriptionText,
        large_price_callout: this.largePriceSelected,
        price_colors: {
          backgrounds: {
            large_price_callout: this.priceDescriptionColor
          }
        }
      };
      //add condition if all the SKU's are same
      if(!this.priceMetaData?.blockSKU){
        let pData2 = {
          price: this.primaryPriceValue,
          sale_price: this.secondaryPriceValue,
          price_strikethrough: this.priceStrikethrough,
          price_colors: {
            fonts: {
              price_comment: '',
              primary: this.primaryColor,
              secondary: this.secondaryColor
            },
            backgrounds: {
              price_label: this.backgroundColor,
              large_price_callout: this.priceDescriptionColor
            }
          }
        };
        Object.assign(pData,pData2);
      }
      this.pricePayload = {
        priceInfo: JSON.stringify(pData)
      };
    } else {
      this.pricePayload = {
        priceInfo: JSON.stringify({
          include_price: true,
          price: this.primaryPriceValue,
          sale_price: this.secondaryPriceValue,
          price_strikethrough: this.priceStrikethrough,
          price_comment: this.priceDescriptionText,
          large_price_callout: this.largePriceSelected,
          price_colors: {
            fonts: {
              price_comment: '',
              primary: this.primaryColor,
              secondary: this.secondaryColor
            },
            backgrounds: {
              price_label: this.backgroundColor,
              large_price_callout: this.priceDescriptionColor
            }
          }
        })
      };
    }
    this.openModalPopup = !this.openModalPopup;
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.DEVICE_UPDATE_DESC;
    if (this.largePriceSelected) {
      this.deviceStore.updateDeviceData({
        priceContents: undefined
      });
    } else if (this.noneSelected) {
      this.deviceStore.updateDeviceData({priceContents: []})
    } else {
      this.deviceStore.updateDeviceData(this.priceContantPayload);
    }
    this.deviceStore.updateDeviceData(this.pricePayload);
    this.isCancel = false;
    this.getPriceStatus.emit(true);
  }

  dismiss() {
    this.dismissFunc.emit('');
    this.openModalPopup = !this.openModalPopup;
    this.isCancel = false;
  }

  closeModal() {
    this.openModalPopup = false;
  }

  closeSuccessModal() {
    this.openSuccessPopup = false;
  }
  toolTipOpen(){
    this.tooltip.open();
  }
}
